import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoFooter = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 135,
	height: 144,
	viewBox: "0 0 135 144",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "SPL Logo",
		clipPath: "url(#clip0_1598_3629)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M66.647 38.6115C57.1391 44.0735 47.7588 49.4607 38.2718 54.9102C36.6891 52.6844 35.1624 50.5376 33.4519 48.1333C39.769 39.3396 47.6844 32.1211 56.4711 25.6238C59.8669 29.9563 63.198 34.2084 66.6484 38.6101L66.647 38.6115Z",
				fill: "#6699CC"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M96.0536 54.7843C86.5512 49.3791 77.0783 43.9877 67.6237 38.6088C68.7195 36.2059 69.7986 33.8361 70.9913 31.2214C81.8463 32.1641 92.1261 35.2715 102.277 39.4254C100.156 44.6562 98.1135 49.7002 96.0536 54.7843Z",
				fill: "#6699CC"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M67.4356 104.93C77.0446 99.4516 86.547 94.0325 96.163 88.5498C97.7823 90.7811 99.3903 92.9958 101.066 95.306C94.6392 104.188 87.003 111.772 77.9272 118.15C74.4263 113.74 70.9646 109.379 67.4342 104.93H67.4356Z",
				fill: "#FF3233"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_4",
				d: "M66.9866 104.951C65.7925 107.51 64.6531 109.952 63.4043 112.626C52.451 111.472 42.0099 108.501 31.8298 104.138C34.0076 98.8454 36.1067 93.7419 38.2368 88.5637C47.8444 94.0395 57.3818 99.4766 66.9852 104.951H66.9866Z",
				fill: "#FF3233"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_5",
				d: "M96.5854 55.5637C99.2964 55.3297 101.944 55.1014 104.644 54.8674C109.21 64.6729 111.939 74.8715 113.034 85.5851C107.575 86.3478 102.085 87.116 96.5911 87.88C96.5868 77.1693 96.5869 66.4613 96.5869 55.5623L96.5854 55.5637Z",
				fill: "#FF9933"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_6",
				d: "M21.0969 57.7755C26.7251 57.017 32.2466 56.2723 37.865 55.5151V88.1941C35.1723 88.4447 32.4571 88.698 29.676 88.9568C25.0651 79.0392 22.1956 68.7243 21.0983 57.7755H21.0969Z",
				fill: "#66CC33"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_7",
				d: "M49.0343 130.182C48.741 126.04 48.466 122.148 48.184 118.171C59.2411 119.096 70.2013 120.012 81.2037 120.933V124.056C70.8973 127.876 60.2191 129.944 49.0343 130.181V130.182Z",
				fill: "#FF3233"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_8",
				d: "M7.05383 85.4023C10.4145 83.1364 13.7358 80.8955 17.102 78.624C21.8953 88.5181 26.6493 98.3333 31.437 108.215C30.5544 108.717 29.6956 109.207 28.7948 109.72C20.1329 102.848 12.8532 94.83 7.05383 85.4023Z",
				fill: "#66CC33"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_9",
				d: "M109.548 116.389C105.852 114.621 102.345 112.945 98.8389 111.267C105.044 102.39 111.228 93.5455 117.483 84.5981C118.238 85.0148 118.966 85.4176 119.999 85.9879C118.206 96.6308 114.623 106.737 109.547 116.387L109.548 116.389Z",
				fill: "#FF9933"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_10",
				d: "M117.789 64.5995C113.076 54.8826 108.345 45.1325 103.601 35.3505C104.471 34.8577 105.205 34.4411 106.026 33.9746C114.656 40.7322 121.763 48.7728 127.513 58.0634C124.241 60.2629 121.058 62.4014 117.789 64.5995Z",
				fill: "#FF9933"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_11",
				d: "M14.5272 57.3865C16.3514 46.5719 20.0754 36.466 25.2812 26.7588C29.0404 28.579 32.6087 30.3078 36.271 32.0809C29.9188 41.0532 23.6058 49.9687 17.2396 58.9603C16.3949 58.4703 15.5824 57.9983 14.5272 57.3865Z",
				fill: "#66CC33"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_12",
				d: "M85.273 13.5387C85.5817 17.3231 85.8833 21.023 86.2075 24.9983C75.271 24.226 64.4385 23.4605 53.568 22.6923V19.935C63.7018 16.0275 74.1976 13.8889 85.273 13.5374V13.5387Z",
				fill: "#6699CC"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_13",
				d: "M2.77266 81.0159H1.39894C0.308663 70.6872 -0.245595 60.3668 0.105201 49.8969C1.67817 49.4387 3.21466 48.9916 4.97565 48.4795C4.23618 59.4062 3.50652 70.1848 2.77406 81.0173L2.77266 81.0159Z",
				fill: "#66CC33"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_14",
				d: "M43.6895 131.621C43.4973 131.886 43.3036 132.15 43.0805 132.457C33.4519 128.453 24.1965 123.707 15.1642 118.353C15.5304 116.873 15.9051 115.361 16.2769 113.862C25.3667 119.756 34.5183 125.693 43.6909 131.621H43.6895Z",
				fill: "#FF9933"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_15",
				d: "M26.603 21.722C26.4402 21.4092 26.2761 21.0936 26.1301 20.8126C34.5408 14.5575 43.3051 8.94049 52.4777 3.91455C53.648 4.98867 54.7972 6.04341 55.8973 7.05386C46.1901 11.9151 36.4548 16.7888 26.603 21.722Z",
				fill: "#6699CC"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_16",
				d: "M119.901 25.0895C119.481 26.7657 119.099 28.2883 118.695 29.8995C109.408 23.8465 100.248 17.8765 91.0414 11.8748C91.2911 11.49 91.5044 11.1619 91.7542 10.7771C101.495 14.8673 110.822 19.6621 119.901 25.0895Z",
				fill: "#66CC33"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_17",
				d: "M78.278 136.678C88.2869 131.808 98.1036 127.033 107.999 122.219C108.221 122.613 108.411 122.951 108.643 123.362C100.151 129.595 91.242 135.112 81.9221 140.115C80.7097 138.971 79.5128 137.843 78.2766 136.678H78.278Z",
				fill: "#FF3233"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_18",
				d: "M134.54 93.191C133.093 93.6311 131.762 94.0367 130.086 94.5475C130.716 83.6955 131.334 73.0401 131.957 62.2989C132.239 62.2851 132.55 62.2699 132.967 62.2505C134.151 72.5543 134.526 82.8332 134.539 93.191H134.54Z",
				fill: "#FF9933"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_19",
				d: "M3.80688 106.871C4.2994 106.349 4.86769 105.747 5.37284 105.213C6.00147 105.78 6.59642 106.316 7.27977 106.933C6.59221 107.456 5.95235 107.945 5.30128 108.441C4.97153 108.095 4.4285 107.524 3.80688 106.872V106.871Z",
				fill: "#FF9933"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_20",
				d: "M5.42046 38.5867C4.7764 37.9527 4.17584 37.3617 3.61316 36.808C4.246 36.1118 4.85498 35.4446 5.50185 34.7332C6.16555 35.4626 6.73104 36.0827 7.35124 36.7637C6.72683 37.352 6.11925 37.9264 5.41906 38.5867H5.42046Z",
				fill: "#66CC33"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_21",
				d: "M128.742 38.5409C128.223 37.9873 127.622 37.345 126.984 36.6654C127.585 36.1145 128.224 35.5248 128.929 34.8784C129.484 35.5027 130.064 36.1519 130.719 36.8855C130.085 37.417 129.476 37.9264 128.742 38.5409Z",
				fill: "#66CC33"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_22",
				d: "M67.3136 140.225C67.9576 140.898 68.5386 141.504 69.1447 142.138C68.5077 142.724 67.8636 143.316 67.1199 144.001C66.525 143.38 65.9553 142.783 65.3267 142.126C65.9707 141.51 66.5937 140.915 67.3136 140.225Z",
				fill: "#FF3233"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_23",
				d: "M68.9848 1.59327C68.307 2.17739 67.6784 2.71999 67.0891 3.22798C66.5615 2.63832 66.0563 2.07358 65.4628 1.41056C66.0858 0.919174 66.6906 0.443017 67.2504 0.00146484C67.7093 0.423639 68.3365 0.999456 68.9848 1.59465V1.59327Z",
				fill: "#6699CC"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_24",
				d: "M127.266 106.865C127.823 106.35 128.38 105.835 128.957 105.304C129.507 105.858 130.019 106.373 130.646 107.004C130.036 107.46 129.418 107.92 128.787 108.392C128.424 108.022 127.855 107.444 127.267 106.865H127.266Z",
				fill: "#FF9933"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_25",
				d: "M57.6793 61.9114C57.8547 61.9114 58.0287 61.9114 58.2041 61.9114C61.6826 61.9155 65.1625 61.8698 68.641 61.9391C71.6943 62 73.7837 63.7288 74.4628 66.5843C74.9848 68.7727 74.6074 70.8462 73.1452 72.647C72.1855 73.8291 70.8917 74.4119 69.3889 74.5724C67.9507 74.7275 66.5054 74.6887 65.0615 74.6928C64.9717 74.6928 64.8777 74.6665 64.7654 74.7247V81.3646H61.1045V65.0064C60.9852 64.915 60.8618 64.9566 60.7467 64.9566C60.2865 64.9566 59.8234 64.9801 59.3702 64.8887C58.4904 64.7129 57.8449 64.0125 57.6695 63.0713C57.553 62.447 57.5502 62.2159 57.6779 61.91L57.6793 61.9114ZM64.8131 71.5688C64.8552 71.5743 64.8987 71.5868 64.9436 71.5868C66.0016 71.5868 67.0624 71.631 68.1162 71.5757C69.2991 71.5134 70.2042 70.9708 70.6392 69.8358C70.9128 69.1229 70.9577 68.3755 70.8777 67.6183C70.7177 66.1234 69.7369 65.142 68.2313 65.0133C67.1859 64.9233 66.1349 64.9621 65.0868 64.9801C64.9984 64.9815 64.9029 64.9829 64.8117 65.0673V71.5688H64.8131Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_26",
				d: "M43.7949 79.085C44.4979 78.2392 45.17 77.4309 45.8547 76.6059C46.0778 76.7914 46.2757 76.9644 46.4834 77.125C47.3449 77.7935 48.2359 78.4137 49.3262 78.6739C50.3688 78.9216 51.3987 78.9715 52.3809 78.4358C53.6677 77.734 54.0297 76.0329 52.6854 75.0196C52.1438 74.6113 51.5629 74.268 50.9525 73.9718C49.9492 73.4846 48.9319 73.0237 47.9469 72.506C46.8734 71.9412 45.8477 71.2921 45.1405 70.2788C43.3304 67.6891 44.3 64.5871 46.5633 63.1102C47.7013 62.3683 48.953 61.971 50.3169 61.935C52.1929 61.8852 54.0704 61.9032 55.9478 61.9129C56.0461 61.9129 56.1527 61.8977 56.2734 61.989C56.4081 62.3323 56.352 62.7074 56.2565 63.0742C55.9829 64.1317 55.1508 65.1699 53.5386 65.174C52.5269 65.1768 51.5138 65.1671 50.5021 65.1851C49.8173 65.1975 49.1845 65.383 48.6316 65.8066C47.4516 66.7104 47.836 68.2289 48.7228 68.7881C49.6798 69.3916 50.7069 69.8373 51.7355 70.2885C52.7416 70.7301 53.728 71.2145 54.6485 71.8097C56.4811 72.996 57.3454 74.6778 57.1714 76.8315C57.003 78.9009 55.9521 80.4262 54.0479 81.3204C52.6461 81.9793 51.1518 82.2423 49.5956 82.0222C47.6901 81.7509 45.9684 81.0685 44.5287 79.7798C44.2804 79.557 44.0432 79.3217 43.7935 79.085H43.7949Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_27",
				d: "M74.7602 61.9681C74.8669 61.8961 74.9904 61.9183 75.1068 61.9183C76.7359 61.9169 78.365 61.9155 79.9941 61.921C80.1864 61.921 80.38 61.9446 80.5694 61.9778C81.2668 62.0968 81.7004 62.5342 81.7958 63.2208C81.8267 63.4436 81.8435 63.672 81.8449 63.8976C81.8533 68.3242 81.8575 72.7508 81.8632 77.1774C81.8632 77.421 81.8561 77.666 81.9024 77.9083C81.9502 78.1574 82.068 78.3111 82.3515 78.3374C82.5535 78.3553 82.7542 78.3678 82.9562 78.3678C84.1251 78.3678 85.2939 78.3678 86.4628 78.3678C87.323 78.3678 87.4212 78.2695 87.4254 77.4127C87.4268 77.1525 87.4254 76.8923 87.4254 76.6113H90.6892C90.7046 76.7276 90.7355 76.8424 90.7341 76.9573C90.7243 77.9069 90.779 78.8592 90.7046 79.8073C90.6176 80.9119 90.1321 81.3632 89.0012 81.4199C88.8089 81.4296 88.6153 81.431 88.4216 81.431C85.7893 81.431 83.1569 81.431 80.5245 81.4282C80.2116 81.4282 79.9001 81.4282 79.5886 81.3798C78.7635 81.2524 78.3973 80.905 78.2766 80.0842C78.2359 79.8073 78.2079 79.5291 78.2079 79.2468C78.2121 74.8838 78.2107 70.5195 78.2107 66.1566C78.2107 65.9033 78.2023 65.6514 78.17 65.3981C78.1377 65.1475 78.0016 65.0313 77.7588 65.0091C77.401 64.9773 77.0404 64.9704 76.6882 64.9081C75.1601 64.6382 74.4614 63.1986 74.7602 61.9695V61.9681Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1598_3629",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 134.54,
			height: 144,
			fill: "white"
		})
	}) })]
});
export default SvgLogoFooter;
